import React, {Component} from 'react';
import PropTypes from 'prop-types';
import getCloudImgLink from '../utils/getCloudImgLink';
import 'lazysizes';

export default class CloudImg extends Component {
    render() {
        const { imageId, format, width, height, square, isGrey, bg } = this.props;
        let imgHeight = square ? width : height;

        let url = getCloudImgLink(imageId, format, width, imgHeight, 1, isGrey, bg);
        let url2x = `${getCloudImgLink(imageId, format, width, imgHeight, 2, isGrey, bg)}  2x`;

        const placeholderHeight = imgHeight ? imgHeight : Math.round(width * (3 / 4));
        const placeholderSrc = `data:image/svg+xml,%0A%3Csvg viewBox="0 0 ${width} ${placeholderHeight}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"%3E%3Crect fill="%23F7FAFC" x="0" y="0" width="${width}" height="${placeholderHeight}" rx="4"%3E%3C/rect%3E%3C/svg%3E`;
        return (
            <img
                data-srcset={url2x}
                data-src={url}
                alt={this.props.alt}
                src={placeholderSrc}
                className={`${this.props.class ? this.props.class : ''} lazyload`}
            />
        );
    }
}

CloudImg.propTypes = {
    imageId: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
    square: PropTypes.bool,
    isGrey: PropTypes.bool,
    alt: PropTypes.string,
    bg: PropTypes.string,
    class: PropTypes.string
};
